import React from 'react';
import { ErrorPageTemplate } from 'components/templates/ErrorPageTemplate';
import { EErrorPageType } from 'models/errorPage';

export const AccessDeniedPage = () => (
  <ErrorPageTemplate type={EErrorPageType.AccessDenied} isStatusVisible={false} />
);
